module.exports = __webpack_public_path__ + "static/media/red_swoop.944b0bce.png";